<div class="card-container">
    <div class="close-button" (click)="close()">
        <img [src]="'svg/closeX.svg' | assetVersion">
    </div>
    <div class="creative-background">
        <img [src]="data.imgUrl">
    </div>
    <div class="information-container">
        <div class="card-header-container">
            <img [src]="data.logoPath" (error)="onImageError($event)" class="logo-image">
            <div class="section-header">{{data.brandName}}</div>
        </div>
        <div class="boxes-container">
            <div class="box">
                <div class="box-header">{{attentionMetricName}}</div>
                <div class="box-value">{{data.attention}}%</div>
            </div>
            <div class="box">
                <div class="box-header">Viewability</div>
                <div class="box-value">{{data.viewability}}%</div>
            </div>
            <div class="box">
                <div class="box-header">CTR</div>
                <div class="box-value">{{data.ctr | percentage}}</div>
            </div>
            <div class="box">
                <div class="box-header">CPM</div>
                <div class="box-value">${{data.cpm}}</div>
            </div>
        </div>
        <div class="information-lines-container">
            <div class="information-line">
                <div class="metric">Dwell Time</div>
                <div class="value">{{data.timeInView}}s</div>
            </div>
            <div class="information-line">
                <div class="metric">Impressions</div>
                <div class="value">{{ data.minImpressions | impressionsRangePipe : data.maxImpressions }}</div>
            </div>
            <div class="information-line">
                <div class="metric">Size</div>
                <div class="value">{{ data.size }}</div>
            </div>
            <div class="information-line">
                <div class="metric">First Seen</div>
                <div class="value">{{data.firstSeen}}</div>
            </div>
            <div class="information-line">
                <div class="metric">Last Seen</div>
                <div class="value">{{data.lastSeen}}</div>
            </div>
        </div>
    </div>
</div>
@if (!hideNavigation) {
    <button class="modal-nav-arrow left" aria-label="Previous" (click)="onPrevClick()">
        <img [src]="'svg/arrow-left.svg' | assetVersion">
    </button>
    <button class="modal-nav-arrow right" aria-label="Next" (click)="onNextClick()">
        <img [src]="'svg/arrow-right.svg' | assetVersion">
    </button>
}